<template>
  <svg
    class="production-info-animation"
    xmlns="http://www.w3.org/2000/svg"
    :style="svgStyle"
    :viewBox="`0 0 ${52 * scale} ${52 * scale}`">
    <g :transform="`scale(${scale}, ${scale})`">
      <circle class="anim-circle" cx="26" cy="26" r="25" fill="none"/>
      <circle class="anim-info" fill="none" cx="26" cy="10" r="0.75" />
      <path class="anim-info" fill="none" d="m26,17zm0,5v20"/>
    </g>
  </svg>
</template>

<style lang="scss" scoped>
$background-color: #78bad4;

.production-info-animation {
  border-radius: 50%;
  display: block;
  stroke-width: 6;
  stroke: #fff;
  stroke-miterlimit: 8;
  box-shadow: inset 0px 0px 0px $background-color;
  animation: fill .3s ease-in-out .3s forwards, scale .2s ease-in-out .8s both;
}

.production-info-animation .anim-circle {
  stroke-dasharray: 166;
  stroke-dashoffset: 166;
  stroke-width: 4;
  stroke-miterlimit: 10;
  stroke: $background-color;
  fill: none;
  animation: stroke 0.5s cubic-bezier(0.65, 0, 0.45, 1) forwards;
}

.production-info-animation .anim-info {
  transform-origin: 50% 50%;
  stroke-dasharray: 48;
  stroke-dashoffset: 48;
  stroke-width: 6;
  stroke-linecap:round;
  animation: stroke 0.2s cubic-bezier(0.65, 0, 0.45, 1) 0.7s forwards;
}

@keyframes stroke {
  100% {
    stroke-dashoffset: 0;
  }
}
@keyframes scale {
  0%, 100% {
    transform: none;
  }
  50% {
    transform: scale3d(1.1, 1.1, 1);
  }
}
@keyframes fill {
  100% {
    box-shadow: inset 0px 0px 0px 120px $background-color;
  }
}
</style>

<script>
// Note: SVG/Styling based on code from StackOverflow 
export default {
  name: 'StationInfoAnimation',
  props: {
    scale: {
      type: Number,
      default: 1.0
    }
  },
  computed: {
    svgStyle() {
      return {
        width: 120 * this.scale,
        height: 120 * this.scale
      }
    }
  },
  methods: {
    restart() {
      // TODO??
    }
  }  
}
</script>